var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame51(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_1802)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 25,
    width: 56.1207,
    height: 56.1207,
    rx: 14.0302,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5377 64.7524H68.583",
    stroke: "#CC99FF",
    strokeWidth: 1.75377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5776 48.8276H48.7069C48.0639 48.8276 47.5377 49.3538 47.5377 49.9968V60.0752C47.5377 60.7182 48.0639 61.2443 48.7069 61.2443H50.5776C51.2206 61.2443 51.7467 60.7182 51.7467 60.0752V49.9968C51.7467 49.3538 51.2206 48.8276 50.5776 48.8276Z",
    stroke: "#CC99FF",
    strokeWidth: 1.75377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9958 45.0981H57.1251C56.4821 45.0981 55.9559 45.6243 55.9559 46.2673V60.0754C55.9559 60.7184 56.4821 61.2445 57.1251 61.2445H58.9958C59.6388 61.2445 60.165 60.7184 60.165 60.0754V46.2673C60.165 45.6243 59.6388 45.0981 58.9958 45.0981Z",
    stroke: "#CC99FF",
    strokeWidth: 1.75377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4136 41.3687H65.543C64.8999 41.3687 64.3738 41.8948 64.3738 42.5378V60.0756C64.3738 60.7186 64.8999 61.2447 65.543 61.2447H67.4136C68.0567 61.2447 68.5828 60.7186 68.5828 60.0756V42.5378C68.5828 41.8948 68.0567 41.3687 67.4136 41.3687Z",
    stroke: "#CC99FF",
    strokeWidth: 1.75377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5846,
    y: 25.5846,
    width: 54.9515,
    height: 54.9515,
    rx: 13.4456,
    stroke: "#00FF66",
    strokeWidth: 1.16918,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_1802",
    x: 0.770472,
    y: 0.447196,
    width: 114.58,
    height: 114.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.67672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6148
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_1802"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_1802",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame51);
export default __webpack_public_path__ + "static/media/frame51.71c6fa04c389c79ea9283740fe59cf1c.svg";
export { ForwardRef as ReactComponent };